module.exports = __webpack_public_path__ + "img/fa-green-energy.6efb84fd.png";